export default (siteName) => [
    // ------------------- 總覽 -------------------
    {
        path: 'analysis/overview',
        name: 'analysis-overview',
        component: () => import('../components/dashboard/Finance/Analysis/Overview.vue'),
        meta: {
            title: `營業收支總覽${siteName}`,
            activeMenu: 'analysis',
            activeSubMenu: 'analysis-overview',
        },
    },
    {
        path: 'analysis/deposit',
        name: 'analysis-deposit',
        component: () => import('../components/dashboard/Finance/Analysis/Deposit/index.vue'),
        meta: {
            title: `存款借款總覽${siteName}`,
            activeMenu: 'analysis',
            activeSubMenu: 'analysis-deposit',
        },
    },

    // ------------------- 分析 -------------------
    {
        path: 'analysis/cash',
        name: 'analysis-cash',
        component: () => import('../components/dashboard/Finance/Analysis/Cash.vue'),
        meta: {
            title: `現金流量分析${siteName}`,
            activeMenu: 'analysis',
            activeSubMenu: 'analysis-cash',
        },
    },
    {
        path: 'analysis/income',
        name: 'analysis-income',
        component: () => import('../components/dashboard/Finance/Analysis/Income.vue'),
        meta: {
            title: `營業收入分析${siteName}`,
            activeMenu: 'analysis',
            activeSubMenu: 'analysis-income',
        },
    },
    {
        path: 'analysis/payout',
        name: 'analysis-payout',
        component: () => import('../components/dashboard/Finance/Analysis/Payout.vue'),
        meta: {
            title: `營業支出分析${siteName}`,
            activeMenu: 'analysis',
            activeSubMenu: 'analysis-payout',
        },
    },
    {
        path: 'analysis/financial-analysis',
        name: 'financial-analysis',
        component: () => import('../components/dashboard/Finance/Analysis/FinancialAnalysis/index.vue'),
        meta: {
            title: `財務資產收支分析${siteName}`,
            activeMenu: 'analysis',
            activeSubMenu: 'financial-analysis',
        },
    },
    {
        path: 'analysis/income-statement',
        name: 'analysis-income-statement',
        component: () => import('../components/dashboard/Finance/Analysis/IncomeStatement.vue'),
        meta: {
            title: `自結損益表${siteName}`,
            activeMenu: 'analysis',
            activeSubMenu: 'analysis-income-statement',
        },
    },
    {
        path: 'analysis/estimate-profit',
        name: 'analysis-estimate-profit',
        component: () => import('../components/dashboard/Finance/Analysis/EstimatePage/indexPage.vue'),
        meta: {
            title: `年度預估營業淨收${siteName}`,
            activeMenu: 'analysis',
            activeSubMenu: 'analysis-estimate-profit',
        },
    },

    // ------------------- 比較 -------------------
    {
        path: 'analysis/comparison',
        name: 'analysis-comparison',
        component: () => import('../components/dashboard/Finance/Analysis/Comparison.vue'),
        meta: {
            title: `同期比較${siteName}`,
            activeMenu: 'analysis',
            activeSubMenu: 'analysis-comparison',
        },
    },
    {
        path: 'analysis/vendor',
        name: 'analysis-vendor',
        component: () => import('../components/dashboard/Finance/Analysis/Vendor.vue'),
        meta: {
            title: `客戶貢獻分析${siteName}`,
            activeMenu: 'analysis',
            activeSubMenu: 'analysis-vendor',
        },
    },
];
